import { MainV3ApiBase } from './base';

export const WorkingLessonApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/working_lessons');
    },
    findAll() {
        return this.base().get();
    },
};
